/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    error: {
        532 : " User not found",
        533 : " No profiles found",
        adminContact : " Please contact your administrator"
    }
};